<template>
  <div>
exhibition-release-new-reject
  </div>
</template>

<script>
export default {
  name:  'exhibition-release-new-reject',
  data() {
    return {

    }
  },
  components: {

  },
  computed: {

  },
  methods: {

  },
}
</script>

<style scoped lang="scss">

</style>

